import { Environment } from '../../environment/environment';
import { TvshopConstants } from '../../tvshop-constants';
import { OmapiIdsUtils } from '../omapi-ids/omapi-ids-utils';
var ImageUtils = /** @class */ (function () {
    function ImageUtils() {
    }
    ImageUtils.getLogoUrlForOmapiId = function (omapiId, componentName) {
        return omapiId ? Environment.environmentConfig().baseUrl +
            TvshopConstants.IMAGES_AEM_PATH +
            OmapiIdsUtils.getCorrectIdForResource(omapiId) +
            (componentName ? '-' + componentName : '') +
            '-logo.png' : '';
    };
    ImageUtils.getBackgroundImageUrl = function (omapiId, componentName, extension) {
        if (extension === void 0) { extension = '.jpg'; }
        return Environment.environmentConfig().baseUrl +
            TvshopConstants.IMAGES_AEM_PATH +
            OmapiIdsUtils.getCorrectIdForResource(omapiId) + '-' +
            componentName + extension;
    };
    ImageUtils.getBannerImageUrl = function (omapiId, componentName) {
        return Environment.environmentConfig().baseUrl +
            TvshopConstants.IMAGES_AEM_PATH +
            OmapiIdsUtils.getCorrectIdForResource(omapiId) + '-' +
            componentName + '-banner.png';
    };
    ImageUtils.getQrCodeImageUrl = function (prefix, language) {
        return Environment.environmentConfig().baseUrl +
            TvshopConstants.IMAGES_AEM_PATH +
            (prefix + "-" + language + ".png");
    };
    return ImageUtils;
}());
export { ImageUtils };
